import React from 'react';
import { Quote } from 'lucide-react';

export default function FounderStory() {
  return (
    <section className="py-24 sm:py-32 border-t border-white/5 bg-[#0B1138]" data-testid="founder-story-section">
      <div className="max-w-5xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center mb-10 sm:mb-14">
          <p className="text-[10px] sm:text-xs font-mono uppercase tracking-[0.3em] text-[#FF4343] mb-3">★ Our story ★</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            From frustration to <span className="text-[#FF4343]">Freddy</span>.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-[auto_1fr] gap-6 sm:gap-10 items-start">
          {/* Founder photo */}
          <div className="mx-auto md:mx-0 flex-shrink-0">
            <div className="relative w-32 h-32 sm:w-44 sm:h-44">
              {/* Red ring like the supplied photo */}
              <div className="absolute inset-0 rounded-full border-[3px] border-[#FF4343]" aria-hidden></div>
              <img
                src="https://customer-assets.emergentagent.com/job_campaign-board/artifacts/sj7m0ozo_Screenshot%202026-06-30%20at%201.06.26%E2%80%AFPM.png"
                alt="Jon Fred, Founder of Freddy Media"
                className="absolute inset-1.5 rounded-full object-cover w-[calc(100%-12px)] h-[calc(100%-12px)]"
                data-testid="founder-photo"
              />
            </div>
            <p className="text-center md:text-left text-[10px] font-mono uppercase tracking-wider text-[#6B7280] mt-3">Jon Fred · Founder</p>
          </div>

          <div className="space-y-4 text-sm sm:text-base text-[#9CA3AF] leading-relaxed">
            <Quote className="w-6 h-6 text-[#FF4343] mb-2 hidden md:block" />
            <p>
              <strong className="text-white">We built Freddy Media out of two frustrations.</strong> Brands were spending $33.80 LinkedIn CPMs on ads
              that nobody trusted — while the executives and top creators on LinkedIn, X, and the biggest B2B newsletters had no clean
              way to monetize the influence they&#39;d already earned.
            </p>
            <p>
              The traditional agencies in the middle were charging 40% retainers, ghosting on deliverables, and
              treating execs and creators like inventory. We built a better one.
            </p>
            <p>
              Today, Freddy Media is a full-service B2B endorsement agency. Every brand gets a dedicated campaign manager who
              sources the right operators, scripts the content, runs the paid amplification, produces the video,
              writes the surrounding copy, and coordinates the events — end-to-end, inside a single account.
              You approve deliverables inside your portal. We invoice through one signed SOW.
              <span className="text-[#FF4343] font-semibold"> No retainers required. No ghosting. No surprise invoices.</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
